import React, { useState, useEffect } from "react";
import { EditBlock, EditBlockOption } from "../EditBlock";
import { Col, Input, Radio } from "antd";
import style from "./EditPanDuan.module.scss";
import { QuestionType } from "../../../../../service/service";
import {
    OptionIsRight,
    OptionType,
    TopicType
} from "../../../../../service/homework";
import _ from "underscore";

interface EditPanDuanProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange: (topic: TopicType) => void;
}

export default function EditPanDuan({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditPanDuanProps) {
    const [innerTopic, setInnerTopic] = useState(topic);
    const [options, setOptions] = useState<OptionType[]>(topic.answers);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic, options]);

    const onCheckChange = (index: number) => {
        const answers = options.map((item, itemIndex) => ({
            ...item,
            isRight:
                itemIndex === index ? OptionIsRight.Right : OptionIsRight.Wrong
        }));

        setOptions(answers);
        setInnerTopic({ ...innerTopic, answers });
    };

    const getValue = () => {
        return _.findIndex(options, { isRight: OptionIsRight.Right });
    };

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.PanDuan}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditPanDuanPure
                onCheckChange={onCheckChange}
                getValue={getValue}
                options={options}
            />
        </EditBlock>
    );
}

export interface EditPanDuanPureProps {
    onCheckChange: (index: number) => void;
    getValue: () => number;
    options: OptionType[];
}

export function EditPanDuanPure({
    getValue,
    onCheckChange,
    options
}: EditPanDuanPureProps) {
    return (
        <React.Fragment>
            <Col span={2} className={style.label}>
                选项：
            </Col>

            <Col span={20}>
                <Radio.Group
                    onChange={e => onCheckChange(e.target.value)}
                    className={style.RadioGroup}
                    value={getValue()}>
                    {options.map((option, index) => (
                        <div className={style.InputOption} key={index}>
                            <Radio
                                className={style.OptionCheckbox}
                                value={index}>
                                {index === 0 ? "正确" : "错误"}
                            </Radio>
                            <Input
                                className={style.OptionInput}
                                placeholder="填写选项"
                                size="large"
                                style={{ visibility: "hidden" }}
                                value={option.content}
                            />
                        </div>
                    ))}
                </Radio.Group>
            </Col>
        </React.Fragment>
    );
}
